import React, { useCallback } from 'react';
import MUIDataTable from "mui-datatables";
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import theme from 'theme';
import { TableCell } from '@material-ui/core'
import { useTheme, useMediaQuery, Typography, Card, CardContent, Grid, IconButton } from '@material-ui/core'
import { ReactComponent as IconSort } from 'assets/svgs/sort.svg';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'lodash';

const CustomTable = (props) => {
    const useStyles = makeStyles(theme => ({
        root: {
            '& table': {
                '& thead th': {
                    textAlign: 'left',
                    color: '#6E7697',
                    padding: `${theme.spacing(1, 2)} !important`,
                    borderBottom: 'none',
                    fontSize: 12,
                    lineHeight: '14px',
                    backgroundColor: '#F2F5FB',
                    '&>span': {
                        justifyContent: 'flex-start'
                    }
                },
                '& tbody': {
                    '& tr': {
                        transition: '0.5s',
                        cursor: 'pointer',
                        '& td': {
                            fontSize: 12,
                            color: theme.palette.app.primary,
                            padding: `${theme.spacing(2, 2)} !important`,
                            textAlign: 'left',
                            backgroundColor: 'white',
                            // borderTop: '1px solid ' + theme.palette.app.outlineborder,
                            // borderBottom: '1px solid ' + theme.palette.app.outlineborder,
                            // '&:first-child': {
                            //     borderLeft: '1px solid ' + theme.palette.app.outlineborder,
                            //     borderTopLeftRadius: 10,
                            //     borderBottomLeftRadius: 10
                            // },
                            // '&:last-child': {
                            //     borderRight: '1px solid ' + theme.palette.app.outlineborder,
                            //     borderTopRightRadius: 10,
                            //     borderBottomRightRadius: 10
                            // },
                        },
                        '&:nth-child(even) td': {
                            backgroundColor: '#F8F9FD'
                        },
                        '&:first-child td': {
                            [`&:nth-child(${props.startIndex ? props.startIndex : 2})`]: {
                                borderTopLeftRadius: 15,
                                overflow: 'hidden'
                            },
                            '&:last-child': {
                                borderTopRightRadius: 15,
                                overflow: 'hidden'
                            },
                        },
                        '&:last-child td': {
                            [`&:nth-child(${props.startIndex ? props.startIndex : 2})`]: {
                                borderBottomLeftRadius: 15,
                                overflow: 'hidden'
                            },
                            '&:last-child': {
                                borderBottomRightRadius: 15,
                                overflow: 'hidden'
                            },
                        },
                        '&:hover': {
                            //backgroundColor: `${theme.palette.app.primary} !important`,
                            '& td': {
                                //color: 'white !important',
                                //fill: 'white !important'
                            }
                        },
                    },
                },
            },
        },
        button: {
            color: theme.palette.app.primary,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
        },
        sortIcon: {
            marginLeft: 4,
            marginTop: 4,
            height: 12
        },
        fixedHeader: {
            position: "sticky",
            zIndex: 100,
            top: 0
        }
        ,
        cardList: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2)
        },
        cardItem: {
            backgroundColor: '#FFFFFF',
            borderRadius: 8,
            // padding: theme.spacing(2),
            boxShadow: '0px 2px 6px rgba(0,0,0,0.06)',
            border: '1px solid #E6E9F0'
        },
        cardRowLabel: {
            color: '#6E7697',
            fontSize: 12
        },
        cardRowValue: {
            color: theme.palette.app.primary,
            fontSize: 14
        }
    }));
    const classes = useStyles();
    const _theme = theme
    const muiTheme = useTheme();
    const isXs = useMediaQuery(muiTheme.breakpoints.down('xs')) && !(props.responseflag === 'none');

    const tableColumns = props.columns

    const renderHeadCell = useCallback(
        ({ index, ...column }, sortColumn, label, sortEnabled, fixedHeader) => (
            <TableCell key={index} onClick={() => sortColumn(index)} className={clsx(classes.button, fixedHeader && classes.fixedHeader)} endIcon={<IconSort />}>
                {label}
                {sortEnabled && <IconSort className={classes.sortIcon} />}
            </TableCell >
        ),
        [classes]
    );
    const columns = tableColumns.map(item => ({
        ...item,
        options: {
            ...item.options,
            customHeadRender: ({ index, ...column }, sortColumn) =>
                renderHeadCell({ index, ...column }, sortColumn, item.label, item.options?.sort, props.options?.fixedHeader),
        }
    }))

    // If small screen and responsive vertical requested, render cards with all columns
    if (isXs) {
        return (
            <section className={props.overwriteStyle ? props.containerStyle : clsx(classes.root, props.containerStyle)}>
                <div className={classes.cardList}>
                    {props.data && props.data.map((row, rowIndex) => (
                        <Card key={row.id || rowIndex} className={classes.cardItem}>
                            <CardContent>
                                <Grid container spacing={1}>
                                    {props.columns.map((col, colIdx) => {
                                        // Skip columns that are hidden in table view (display: false)
                                        if (col.options && col.options.display === false) {
                                            return null;
                                        }
                                        
                                        // Use col.name first (as MUI DataTable does), then fall back to col.key
                                        const fieldName = col.name || col.key;
                                        const field = col.key || col.name;
                                        const label = col.label || field;
                                        
                                        // build rowData array consistent with MUI DataTable tableMeta.rowData
                                        const rowData = props.columns.map(c => {
                                            const f = c.name || c.key;
                                            // Handle nested paths (e.g., "interventionSEL.datesReelles.dateDebut")
                                            if (f && f.includes('.')) {
                                                return _.get(row, f);
                                            }
                                            return row[f];
                                        });
                                        
                                        // Get value from row - handle nested paths properly
                                        let value;
                                        if (fieldName && fieldName.includes('.')) {
                                            // If name contains dots, it's a nested path - use lodash get
                                            value = _.get(row, fieldName);
                                        } else {
                                            // Otherwise, use direct property access
                                            value = row[field];
                                        }
                                        
                                        // Use customBodyRender if provided and provide a tableMeta-like object
                                        if (col.options && col.options.customBodyRender) {
                                            const tableMeta = { rowIndex, rowData, columnIndex: colIdx };
                                            try {
                                                // try the common (value, tableMeta) signature
                                                value = col.options.customBodyRender(value, tableMeta);
                                            } catch (err) {
                                                try {
                                                    // fallback to (value, tableMeta, row)
                                                    value = col.options.customBodyRender(value, tableMeta, row);
                                                } catch (err2) {
                                                    // fallback to raw value
                                                }
                                            }
                                        }
                                        return (
                                            <Grid item xs={12} key={field}>
                                                <Typography className={classes.cardRowLabel}>{label}</Typography>
                                                <div className={classes.cardRowValue}>{value}</div>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </section>
        )
    }

    return (
        <section className={props.overwriteStyle ? props.containerStyle : clsx(classes.root, props.containerStyle)}>
            <ThemeProvider theme={{
                ..._theme,
                overrides: {
                    ..._theme.overrides,
                    MuiToolbar: {
                        root: {
                            backgroundColor: "transparent"
                        }
                    },
                    MUIDataTableFilterList: {
                        root: {
                            backgroundColor: "#FAFAFD",
                            margin: 0
                        }
                    },
                    MuiFormControl: {
                        root: {
                            backgroundColor: "#FAFAFD"
                        }
                    },
                    MUIDataTableFilter: {
                        root: {
                            backgroundColor: "#FAFAFD"
                        }
                    },
                    MuiSelect: {
                        root: {
                            backgroundColor: "#FAFAFD"
                        }
                    },
                    MuiPaper: {
                        root: {
                            backgroundColor: 'transparent'
                        }
                    },
                    MUIDataTableSelectCell: {
                        root: {
                            display: "none"
                        }
                    }
                }
            }}>
                <MUIDataTable  {...props}
                    columns={columns} />
            </ThemeProvider>
        </section>
    );
};
CustomTable.propTypes = {
    startIndex: PropTypes.any,
    columns: PropTypes.any,
    overwriteStyle: PropTypes.any,
    containerStyle: PropTypes.any,
    options: PropTypes.any
};
export default CustomTable;
